export default "__VITE_ASSET__DX$Vd9nK__"